import { Observable } from 'rxjs';
import {Component, EventEmitter, inject, Input, OnInit, Output, ViewChild} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';

import { DocumentTypeService, IDocumentType } from '../../services/document-type.service';
import { IDocument } from '../../interfaces/document.interface';
import {environment} from "../../../environments/environment";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";
import {ModalesService} from "../../services/modales.service";
import {AuthService, IStorageItem} from "../../services/auth.service";
import {NgxTurnstileComponent} from "ngx-turnstile";
import {EncriptionService} from "../../services/encription.service";

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrl: './search-box.component.scss',
})
export class SearchBoxComponent implements OnInit {
    @Output() submited = new EventEmitter<IDocument>();
    @Output() showTratamientoDatos = new EventEmitter<boolean>();
    @Input() title = '';
    @Input() siteKey = '';
    @ViewChild('captchaRef') captchaRef!: NgxTurnstileComponent;

    warningLabelText = 'Este servicio está disponible solo para cédula de ciudadanía.';
    docTypeLabel = 'Tipo de documento';
    docTypePlaceholder = 'Seleccione un tipo de documento';
    docNumLabel = 'Número de documento';
    docNumPlaceholder = 'Número de documento';
    fechaNacimientoLabel = 'Fecha de nacimiento';
    fechaExpedicionLabel = 'Fecha de expedición';
    tratamientoDatosLabel = 'tratamiento de los datos personales.';
    submitLabel = 'Consultar';

    docTypeError = 'Seleccione un tipo de documento';
    docNumberError = 'Ingrese el número de documento sin puntos, guiones, espacios, ni caracters especiales; Solo se permiten dígitos.';
    reCaptchaError = 'Marque la casilla de verificación de seguridad.';
    fechaNacimientoError = 'Seleccione su fecha de nacimiento.';
    fechaExpedicionError = 'Seleccione la fecha de expedición del documento seleccionado.';
    tratamientoDatosError = 'Debe aceptar el tratamiento de datos personales.'

    disableDocTytpe = true;
    documentTypes$!: Observable<IDocumentType[]>;
    searchForm: FormGroup;
    verPreguntas= false;
    urlPreguntas : SafeResourceUrl = "";
    validacionRecaptcha: any;
    conteoCaptcha = 0;
    reCaptchaS : string[]= []

    private documentTypeService = inject(DocumentTypeService);
    private formBuilder = inject(FormBuilder);
    private sanitizer = inject(DomSanitizer);
    private authService = inject(AuthService);
    private encriptionService = inject(EncriptionService);

    constructor(){
        this.documentTypes$ = this.documentTypeService.getDocumentTypes();

        this.searchForm = this.formBuilder.group({
            docType: [{value: 'CC', disabled: this.disableDocTytpe}, Validators.required],
            docNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$")]],
            tratamientoDatos: [false, Validators.requiredTrue],
            reCaptcha: ['', Validators.required]
        });
    }

    ngOnInit(): void {

        window.addEventListener('message', (event) => {
            // Validar el origen si es necesario
            // if (event.origin !== 'http://15.124.12.21:4200') return;
            this.verPreguntas = false;
            const data = event.data;
            if (data?.tipo === 'resultadoOperacion') {
                if (data.valor.codigo === 'E01') {
                    //alert('✅ La operación fue exitosa');
                    this.continueValidation(data.valor);

                } else {
                    this.searchForm.reset()
                    this.searchForm.get("docType")?.setValue('CC')
                    this.continueValidation(data.valor);
                    console.log('❌ La operación falló');
                }
            }
        });
    }

    get docType(): AbstractControl {
        return this.searchForm.controls['docType'];
    }

    get docNumber(): AbstractControl {
        return this.searchForm.controls['docNumber'];
    }

    get tratamientoDatos(): AbstractControl {
        return this.searchForm.controls['tratamientoDatos']
    }

    get reCaptcha(): AbstractControl {
        return this.searchForm.controls['reCaptcha']
    }
    continueValidation(estado: {codigo: string; descripcion: string}){
        const fecha = new Date();
        const document:IDocument = {
            'tipoDocumento' : this.searchForm.get("docType")?.value,
            'numDocumento' : this.searchForm.get("docNumber")?.value,
            'fechaNacimiento' : this.getDateWithFormat(fecha.toString()),
            'fechaExpedicion' : this.getDateWithFormat(fecha.toString()),
            'reCaptcha' : this.reCaptchaS[1],//ASIGNA EL SEGUNDO CAPCHA SIN USAR
            'resultado': estado
        }

        this.submited.emit(document);
    }
    handleSubmitForm(){
        const url = environment.componentPreguntas;
        const tipoIdentificacion = '13'; // ASIGNA VALOR POR DEFECTO PARA TIPO DE DOCUMENTO CC
        const identificacion = this.searchForm.get("docNumber")?.value;
        const dato= localStorage.getItem('token')
        const token = dato !== null ? JSON.parse(dato).idToken : 'X';
        const clientId = dato !== null ? JSON.parse(dato).clientId : 'X';

        if (token === 'X' || clientId === 'X'){
           /* this.modalesService.openModalError(
                'Atención',
                'Se presentó inconveniente en obtener el token de seguridad, recargue la pagina e intente de nuevo.', null);*/
            console.log(`Se invocó el servicio sin el token`)
            return ;
        }else{
            this.verPreguntas = true;
            const tipoIdenEnc = this.encriptionService.encriptarAesBase64(tipoIdentificacion)
            const identificacionEnc = this.encriptionService.encriptarAesBase64(""+identificacion)
           this.resetCaptcha()
            //console.log(`${url}/${tipoIdenEnc}/${identificacionEnc}/${clientId}/${token}`)
            this.urlPreguntas = this.sanitizer.bypassSecurityTrustResourceUrl(`${url}/${tipoIdenEnc}/${identificacionEnc}/${clientId}/${token}`);
        }

    }

    openTratamientoDatos(){
        this.showTratamientoDatos.emit(true);
    }

    private getDateWithFormat(date: string): string {
        return new Date(date).toLocaleDateString("en-GB")
    }


    private inicializeToken(token: string) {
        //console.log(`USO 1 ${token}]`)

        const storedToken:IStorageItem | null = this.authService.getWithTTL();
        if(!storedToken) {
            this.authService.getToken(token).subscribe({
                next: (response: any) => {
                    this.authService.setWithTTL(response.idToken, response.clientId, response.expireIn);
                },
                error: (error: any) => {
                    console.error("Error en la autenticación."+ error);
                }
            });
        } else {
            console.log('Continua proceso de consulta despues de preguntas. ')
        }
    }


    resolverCaptcha(token: string | null) {
        if (token)
            this.reCaptchaS[this.conteoCaptcha++] = token
        if (token && this.conteoCaptcha == 1){
            this.resetCaptcha()
            this.inicializeToken(token);
        }/*else{
           console.log(this.reCaptchaS)
        }*/


    }

    resetCaptcha(){
        if (window['turnstile']) {
            // @ts-expect-error turnstile no está tipado en TS
            window['turnstile'].reset();
        }
    }

}
